// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/Expanded/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Ledger_New_Content_Receivables_Content_Expanded_Content($receivable_id: numeric!, $patient_person_id: numeric!) {
  vaxiom_transactions(
    where: {
      receivable_id: { _eq: $receivable_id }
      # exclude reversed transactions since those are displayed as part of the initial transaction
      dtype: {
        _nin: [
          DiscountReverseAdjustment
          PaymentPlanRollback
          unapplied_payment
        ]
      }
    }
    order_by: { sys_created: asc }
  ) {
    id
    dtype
    amount
    sys_created
    sys_created_by
    notes
    created_by_user {
      id
      person {
        id
        first_name
        last_name
      }
    }
    misc_fee_charge {
      id
      name
    }
    retail_fee {
      id
      retail_item {
        id
        name
      }
    }
    discount_adjustment {
      id
      discount_adjustment_type
      discount {
        id
        name
      }
      discount_reverse_adjustments {
        id
        discount_adjustment_id
      }
    }
    installment_charge {
      id
      payment_plan_id
    }
    payment_plan {
      id
      payment_plan_rollback_id
      rollback_date
    }
    charge_transfer_adjustment {
      id
      transfer_charge_type
      transfer_charge {
        id
        transfer_charge_type
        charge_transfer_adjustment_id
        transaction {
          id
          receivable {
            id
            human_readable_id
            patient {
              id
              person {
                id
                first_name
                last_name
              }
            }
          }
        }
      }
    }
    transfer_charge {
      id
      transfer_charge_type
      charge_transfer_adjustment_id
      charge_transfer_adjustment {
        id
        transfer_charge_type
        transaction {
          id
          receivable {
            id
            human_readable_id
            patient {
              id
              person {
                id
                first_name
                last_name
              }
            }
          }
        }
      }
    }
    applied_payment {
      id
      unapplied_payment {
        id
        transaction {
          id
          sys_created
          sys_created_by
          notes
          created_by_user {
            id
            person {
              id
              first_name
              last_name
            }
          }
        }
      }
      payment {
        id
        payment_type
        check_number
        last_four_digits
        transaction_id
        payer_name
        type_info
        notes
        sys_created
        source
        human_readable_id
        account {
          id
          account_type
          person_payment_account {
            id
            payer_person {
              id
              first_name
              last_name
              from_person_relationships(
                where: { to_person: { _eq: $patient_person_id } }
              ) {
                id
                type
                role
              }
              patient {
                id
                _id
              }
            }
          }
          insurance_payment_account {
            id
            insurance_company {
              id
              carrier_name
            }
          }
        }
        payment_type_record {
          id
          name
        }
        organization {
          id
          name
        }
      }
    }
    refund {
      id
      refund_type
    }
    receivable {
      id
      due_date
      payment_account {
        id
        account_type
        person_payment_account {
          id
          payer_person {
            id
            first_name
            last_name
          }
        }
        insurance_payment_account {
          id
          insurance_company {
            id
            carrier_name
          }
        }
      }
    }
  }
}

`